module.exports = __webpack_public_path__ + "img/ic_launcher_round.737ca4da.png";